module.exports = __webpack_public_path__ + "img/settings-1_1280.8d678c0e.webp";